module.exports = __webpack_public_path__ + "img/bookkeep.e86b8251.png";